import geoConfig from 'Config/geos';
/**
 * Geos reducer, gotta do some fancy magic here
 * @param  {object} acc          routing state
 * @param  {object} payload      action payload
 * @param  {object} routingState current routing state
 * @return {object}              new routing state
 */
export default function geos(acc, payload, routingState) {
  const routingVal = (
    routingState.geos &&
    (Array.isArray(routingState.geos) ? routingState.geos : [routingState.geos])
  ) || [];

  if ('all' === routingVal[0] && 'all' !== payload) {
    return {
      ...acc,
      geos: geoConfig
        .reduce((acc1, arr) => acc1.concat(arr), [])
        .map((geo) => geo[0])
        .filter((geo) => geo !== payload),
    };
  } else if ('all' !== routingVal[0] && 'all' === payload) {
    return { ...acc, geos: payload };
  } else if ('all' === routingVal[0] && 'all' === payload) {
    return { ...acc, geos: [] };
  }
  return {
    ...acc,
    geos: (-1 !== routingVal.indexOf(payload) ?
      routingVal.filter((vals) => vals !== payload) :
      routingVal.concat(payload)
    ),
  };
}



// WEBPACK FOOTER //
// ./app/middleware/router/geos.js